import React from "react";
import "../../styles/AboutUsSection.css";

function AboutUsSection() {
  return (
    <section className="about-us">
      <h2>About Us</h2>
      <p>
        Wibitec is a leader in the field of industrial electrical and electronic
        components. We specialize in providing high-quality products and
        exceptional customer service.
      </p>
    </section>
  );
}

export default AboutUsSection;
